import { sort } from 'radash'

import { Feature } from '@wwt/entities/search-response'

import { getFeaturePriority } from './getFeaturePriority.ts'

/**
 * Sort features by feature or selected option wwtPriority or integrationPriority
 *
 * @param features - Array of features
 * @param optionPriority - If true, sort by selected option priority if exists.
 * 												 Is false, sort by feature priority
 */
export const getWWTSortedFeatures = (
	features: Feature[],
	optionPriority = true
): Feature[] => {
	return sort(
		features,
		feature => getFeaturePriority(feature, optionPriority ? 1 : 0),
		true
	)
}
